import { render, staticRenderFns } from "./Markets.vue?vue&type=template&id=6f12ec0d&scoped=true"
import script from "./Markets.vue?vue&type=script&lang=js"
export * from "./Markets.vue?vue&type=script&lang=js"
import style0 from "./Markets.vue?vue&type=style&index=0&id=6f12ec0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f12ec0d",
  null
  
)

export default component.exports